import _slicedToArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { disposables as s } from '../../utils/disposables.js';
import { createStore as i } from '../../utils/store.js';
import { adjustScrollbarPadding as l } from './adjust-scrollbar-padding.js';
import { handleIOSLocking as d } from './handle-ios-locking.js';
import { preventScroll as p } from './prevent-scroll.js';
function m(e) {
  var n = {};
  var _iterator = _createForOfIteratorHelper(e),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var t = _step.value;
      Object.assign(n, t(n));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return n;
}
var a = i(function () {
  return new Map();
}, {
  PUSH: function PUSH(e, n) {
    var o;
    var t = (o = this.get(e)) != null ? o : {
      doc: e,
      count: 0,
      d: s(),
      meta: new Set()
    };
    return t.count++, t.meta.add(n), this.set(e, t), this;
  },
  POP: function POP(e, n) {
    var t = this.get(e);
    return t && (t.count--, t.meta.delete(n)), this;
  },
  SCROLL_PREVENT: function SCROLL_PREVENT(_ref) {
    var e = _ref.doc,
      n = _ref.d,
      t = _ref.meta;
    var o = {
        doc: e,
        d: n,
        meta: m(t)
      },
      c = [d(), l(), p()];
    c.forEach(function (_ref2) {
      var r = _ref2.before;
      return r == null ? void 0 : r(o);
    }), c.forEach(function (_ref3) {
      var r = _ref3.after;
      return r == null ? void 0 : r(o);
    });
  },
  SCROLL_ALLOW: function SCROLL_ALLOW(_ref4) {
    var e = _ref4.d;
    e.dispose();
  },
  TEARDOWN: function TEARDOWN(_ref5) {
    var e = _ref5.doc;
    this.delete(e);
  }
});
a.subscribe(function () {
  var e = a.getSnapshot(),
    n = new Map();
  var _iterator2 = _createForOfIteratorHelper(e),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _step2$value = _slicedToArray(_step2.value, 1),
        t = _step2$value[0];
      n.set(t, t.documentElement.style.overflow);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  var _iterator3 = _createForOfIteratorHelper(e.values()),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _t = _step3.value;
      var o = n.get(_t.doc) === "hidden",
        c = _t.count !== 0;
      (c && !o || !c && o) && a.dispatch(_t.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", _t), _t.count === 0 && a.dispatch("TEARDOWN", _t);
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
});
export { a as overflows };